import { PropsWithChildren, useEffect, useState } from 'react';
import cloneObject from '../functions/clone.object';
import createGuid from '../functions/create.guid';
import useTrait from '../hooks/use.trait';
import Div from './div';

interface H1Props {
    id?: string
    className?: string
}

const H1 = (props: PropsWithChildren<H1Props>) => {
    const [id] = useState(props.id ? props.id : createGuid());
    const hasBeenFocused = useTrait(false);

    useEffect(() => {
        if (hasBeenFocused.get())
            return;
        document.getElementById(id)?.focus();
        hasBeenFocused.set(true);
    });

    const clonedProps: any = cloneObject(props);
    delete clonedProps.id;

    return <>
        <Div
            paddingBottom={2}
            paddingTop={5} paddingTopMD={3}
        >
            <h1
                className={'ds-h1'}
                id={id}
                tabIndex={-1}
                {...clonedProps}
            >{props.children}</h1>
        </Div>
    </>;
};

export default H1;